export enum SubscriptionTypes {
    All = 'all',
    My = 'my',
    Other = 'other',
}
